import * as ReactDOM from "react-dom/client";
import {refreshPageDataCache} from "../lib/pageDataCacheRefresh";

// Store roots in a WeakMap to allow proper cleanup
const roots = new WeakMap();

const browserHydrateFunction = () => {
  /**
   * 2026-09-19: the page-data refresh (OA-267) no longer BLOCKS the first
   * render. Measured on www.duffloo.com: Gatsby's loader had already fetched
   * this page's page-data.json (592→712ms) BEFORE this function ran, and the
   * `element` handed to us is built from that in-memory copy — so awaiting a
   * second, cache-bypassing fetch (725→826ms) never changed what renders. It
   * only held the page non-interactive for one more round trip (up to ~1.8s
   * on a phone network).
   *
   * What still protects returning visitors from a stale cached page-data:
   *   • this refresh still runs, in the background, and REPLACES the browser's
   *     cache entry, so the next load (and Gatsby's own build-hash reload) is
   *     current;
   *   • since 2026-09-12 the host sends `max-age=0, must-revalidate` on HTML,
   *     page-data and app-data (static/.htaccess), so no new stale entries form.
   */
  return (element, container) => {
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : "/";
    refreshPageDataCache(pathname);
    let root = roots.get(container);
    if (!root) {
      root = ReactDOM.createRoot(container);
      roots.set(container, root);
      // Store root reference on container for potential cleanup by Gatsby's head-export-handler
      container._reactRootContainer = root;
    }
    // 2026-09-19: this renders from scratch (createRoot, not hydrateRoot), so
    // the server-painted DOM is replaced and its CSS animations would restart.
    // `--t` is the time since first paint; the intro and hero subtract it from
    // their delays, so the re-created elements continue instead of replaying.
    if (typeof window !== "undefined" && window.__dufflooT0 != null) {
      document.documentElement.style.setProperty(
        "--t",
        `${Math.round(performance.now() - window.__dufflooT0)}ms`
      );
    }
    root.render(element);
  };
};

export default browserHydrateFunction;
